import { isEmpty } from "./validationUtil";

// @since NEXT_VERSION
// Mirrors DepartmentAdapter#CODE_PATTERN on the backend. The `i` flag is deliberate: the form
// upper-cases before submitting, so lowercase typing must not be reported as invalid mid-entry.
export const DEPARTMENT_CODE_PATTERN = /^[A-Z0-9][A-Z0-9-]{0,19}$/i;

const VALID_STATUSES = ["ACTIVE", "DISABLED"];

export const DEPARTMENT_FIELD_MESSAGES = {
  code: {
    required: "Required. Up to 20 characters, letters/digits/hyphen.",
    invalid: "Use letters, digits and hyphens only, starting with a letter or digit.",
  },
  displayName: {
    required: "Required.",
    tooLong: "Display name must be at most 100 characters.",
  },
  description: { tooLong: "Description must be at most 255 characters." },
  status: { required: "Pick Active or Disabled." },
};

// @since NEXT_VERSION
export const isValidDepartmentCode = (code) =>
  !isEmpty(code) && DEPARTMENT_CODE_PATTERN.test(String(code).trim());

// @since NEXT_VERSION
export const validateDepartmentObject = (departmentObject) => {
  if (!departmentObject) return false;

  let isValid = isValidDepartmentCode(departmentObject.code);
  isValid = isValid && !isEmpty(departmentObject.displayName);
  isValid = isValid && String(departmentObject.displayName).length <= 100;
  isValid =
    isValid &&
    (isEmpty(departmentObject.description) ||
      String(departmentObject.description).length <= 255);
  isValid =
    isValid &&
    (isEmpty(departmentObject.status) ||
      VALID_STATUSES.includes(String(departmentObject.status).toUpperCase()));

  return isValid;
};
